import { useIntl } from 'react-intl';

import EmptyDashboardIcon from '@/assets/icons/empty-dashboard.svg';
import { EmptyState } from '@/components/ui/empty-state';
import { useNavigationPaths } from '@/hooks/use-navigation-paths';

interface NoOpeningsProps {
  // When set, the table is empty because a search returned no matches, not
  // because the dashboard has no openings pinned yet — the CTA to add
  // openings doesn't apply here, so we show a search-specific message instead.
  searchQuery?: string;
}

export function NoOpenings({ searchQuery }: NoOpeningsProps) {
  const intl = useIntl();
  const { allOpeningsPath } = useNavigationPaths();

  if (searchQuery) {
    return (
      <EmptyState
        header={intl.formatMessage(
          {
            defaultMessage: "No results for ''{searchQuery}''",
            description:
              'Dashboard search returned no matching openings; {searchQuery} is the text the user typed',
          },
          { searchQuery },
        )}
        description={intl.formatMessage({
          defaultMessage: 'Try a different opening name.',
          description: 'Suggests the user adjust their dashboard search term',
        })}
      />
    );
  }

  return (
    <EmptyState
      icon={EmptyDashboardIcon}
      header={intl.formatMessage({
        defaultMessage: 'Add openings to your dashboard',
        description:
          'Empty org dashboard: prompt to follow roles from Openings',
      })}
      description={intl.formatMessage({
        defaultMessage:
          'Start adding openings to your dashboard to track their data.',
        description:
          'Why the dashboard is empty: no openings pinned for org analytics',
      })}
      buttonTitle={intl.formatMessage({
        defaultMessage: '+ Add openings',
        description: 'CTA: go to openings list to add roles to this dashboard',
      })}
      link={allOpeningsPath}
    />
  );
}
